















































































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";

import { formatCurrency } from "@/shared/currency";
import {
  tint,
  convertColorToHex,
  covertHexToRgbColor
} from "@/shared/colorAdjuster";
import { useThemeStore } from "@/shared/store/theme";


const TOTAL_KEY = "total";
const OTHER_KEY = "other";
const EMPLOYER_KEY = "employer";
const EMPLOYEE_KEY = "employee";

@Component
export default class ContributionsProgressBar extends Vue {
  themeStore = useThemeStore();

  @Prop()
  total: number;

  @Prop()
  employer: number;

  @Prop()
  employee: number;

  @Prop()
  other: number;

  @Prop()
  planYear: number;

  formatCurrency = formatCurrency;
  width = 0;
  rectRadius = 10;

  TOTAL_KEY = TOTAL_KEY;
  OTHER_KEY = OTHER_KEY;
  EMPLOYER_KEY = EMPLOYER_KEY;
  EMPLOYEE_KEY = EMPLOYEE_KEY;

  // percentages

  get otherPecent () {
    if (!this.total || !this.other) {
      return 0;
    }
    return (this.other / this.total) * 100;
  }

  get employerPercent () {
    if (!this.total || !this.employer) {
      return 0;
    }
    return (this.employer / this.total) * 100;
  }

  get employeePercent () {
    if (!this.total || !this.employee) {
      return 0;
    }
    return (this.employee / this.total) * 100;
  }

  get percentageValueDictionary () {
    const percentageValueDictionary = {};
    percentageValueDictionary[OTHER_KEY] = {
      order: 1,
      value: this.otherPecent,
      previousSum: 0
    };
    percentageValueDictionary[EMPLOYER_KEY] = {
      order: 2,
      value: this.employerPercent,
      previousSum: this.otherPecent
    };
    percentageValueDictionary[EMPLOYEE_KEY] = {
      order: 3,
      value: this.employeePercent,
      previousSum: this.otherPecent + this.employerPercent
    };

    return percentageValueDictionary;
  }

  get lightenSecondaryColorHex (): string {
    const secondaryColorRgb = covertHexToRgbColor(this.themeStore.secondaryColor);
    const tintedColor = tint(secondaryColorRgb.r, secondaryColorRgb.g, secondaryColorRgb.b, 0.5);

    return convertColorToHex(tintedColor);
  }

  get lightenPrimaryColorHex (): string {
    const primaryColorRgb = covertHexToRgbColor(this.themeStore.primaryColor);
    const tintedColor = tint(primaryColorRgb.r, primaryColorRgb.g, primaryColorRgb.b, 0.5);

    return convertColorToHex(tintedColor);
  }

  getPercentageValue (key) {
    return this.percentageValueDictionary[key];
  }

  mounted () {
    window.addEventListener("resize", this.computeMaxWidth);
    this.computeMaxWidth();
  }

  beforeDestroy () {
    window.removeEventListener("resize", this.computeMaxWidth);
  }

  computeMaxWidth () {
    const container: any = this.$refs.container;
    const containerWidthMinusMargin = container.clientWidth - 20;

    this.width = containerWidthMinusMargin;
  }
}
